import Vue from 'vue';
import AxiosService, { status } from '@/services/AxiosService';
import ErrorService from '@/services/ErrorService';
import { SET_TOKEN, START_LOADING, END_LOADING } from '@/store/mutation-types';

export default () => {
  const { store } = Vue.prototype;
  const apiWrapper = {};
  function processData(data) {
    if (data && data.insert) {
      data.delete.forEach(object => {
        if(object.class != 'StationRelation') {
          store.dispatch('deleteObject', object);
        }
      });
      data.insert.forEach(object => {
        if(object.class == 'ReOrder') {
          object.items = JSON.parse(object.items);
        }
        if(object.class == 'Product' && object.cookingOptions) {
          object.cookingOptions = JSON.parse(object.cookingOptions);
        }
        if(object.class != 'StationRelation') {
          store.dispatch('saveObject', object);
        } else {
          store.getters.getMap('stations')[object.station].stationRelations[object.productGroup] = object;
        }
      });
      data.update.forEach(object => {
        const oldObject = store.getters.getObjectFromApi(object);
        for(const property in object.changes) {
          if(property == 'cookingOptions') {
            Vue.set(oldObject, property, JSON.parse(object.changes[property][1]));
          } else {
            Vue.set(oldObject, property, object.changes[property][1]);
          }
        }
      });
    }
  }
  apiWrapper.get = (url, inline = false, loading = false, responseType = 'json') => {
    if (loading) {
      store.commit(START_LOADING);
    }
    return AxiosService(inline, 'application/json', responseType)
      .get(url)
      .then(response => response.data)
      .catch(error => (inline ? error : null))
      .finally(() => { if (loading) { store.commit(END_LOADING); } });
  };

  apiWrapper.post = (url, data, inline = false, contentType = 'application/json') => {
    store.commit(START_LOADING);
    return AxiosService(inline, contentType)
      .post(url, data)
      .then((response) => {
        if (response.headers['x-pos-password-encrypted']) {
          store.commit(SET_TOKEN, {
            user: response.data.user,
            token: response.headers['x-pos-password-encrypted'],
            currency: response.data.currency,
          });
        }
        processData(response.data);
        return response.data;
      })
      .catch((error) => {
        if (inline) {
          error.errors = ErrorService.inlineError(error);
          return error;
        }
        return null;
      })
      .finally(() => { store.commit(END_LOADING); });
  };

  apiWrapper.put = (url, data, inline = false, contentType = 'application/json') => {
    store.commit(START_LOADING);
    return AxiosService(inline, contentType)
      .put(url, data)
      .then(response => {
        processData(response.data);
        return response.data
      })
      .catch(error => (inline ? error : null))
      .finally(() => { store.commit(END_LOADING); });
  };

  apiWrapper.patch = (url, data, inline = false) => {
    store.commit(START_LOADING);
    return AxiosService(inline)
      .patch(url, data)
      .then(response => {
        processData(response.data);
        return response.data;
      })
      .catch(error => (inline ? error : null))
      .finally(() => { store.commit(END_LOADING); });
  };

  apiWrapper.delete = (url) => {
    store.commit(START_LOADING);
    return AxiosService()
      .delete(url)
      .then(response => {
        processData(response.data);
        return response.data;
      })
      .catch(error => null)
      .finally(() => { store.commit(END_LOADING); });
  };

  apiWrapper.status = status;

  apiWrapper.formData = (data) => {
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      if(Array.isArray(data[key])) {
        if(data[key].length > 0) {
          formData.append(key, data[key]);
        } else {
          formData.append(key, []);
        }
      } else {

        if(key == 'printBillCommission' && !data[key]) {
          formData.append(key, false);
        } else if(data[key] || data[key] === false) {

          formData.append(key, data[key]);
        } else if(key == 'mailList' || key == 'mailListDay'){
          formData.append(key, '');
        }
      }
    });
    return formData;
  }

  return apiWrapper;
};
